// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { MainPanel } from "types";
import { IState } from "states/states";
import { IAction } from "actions";
import { Bus, IEnergyMeter, IModule } from "parameter";
import { getEnergySourceName } from "guiutils";

import EnergyMeterModel from "model/energymeter";

interface IEnergyMeterExtProps {
  index: number;
  showSource: boolean;
  showNumber: boolean;
  showModule: boolean;
}

interface IEnergyMeterProps {
  parameter: IEnergyMeter;
  value: number | undefined;
  modules: IModule[] | undefined;
}

const mapStateToProps = (state: IState, ownProps: IEnergyMeterExtProps) => {
  const props: IEnergyMeterProps = {
    parameter: state.parameter!.energymeter[ownProps.index],
    value: state.data.energymeter[ownProps.index],
    modules: state.parameter?.module,
  };
  return props;
};

interface IEnergyMeterDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IEnergyMeterDispatch = {};
  return dispatchProps;
};

class EnergyMeterComponent extends React.Component<
  IEnergyMeterExtProps & IEnergyMeterProps & IEnergyMeterDispatch
> {
  public render() {
    const energymeter = new EnergyMeterModel(this.props.parameter, this.props.value);
    const module =
      this.props.parameter.bus === Bus.MODULE
        ? this.props.modules?.find((curItem) => curItem.id === this.props.parameter.module)
        : undefined;

    return (
      <tr className="energymeteritem">
        <td>{this.props.parameter.name}</td>
        {this.props.showModule && (
          <td className="optional">
            <Link to={`../${MainPanel.MODULES}`} style={{ textDecoration: "none" }}>
              {module?.name}
            </Link>
          </td>
        )}
        {this.props.showSource && (
          <td className="optional">{getEnergySourceName(this.props.parameter.energySource)}</td>
        )}
        {this.props.showNumber && <td className="optional">{this.props.parameter.number}</td>}
        <td className="value-col">{energymeter.getText()}</td>
      </tr>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EnergyMeterComponent);
